import React, { useEffect, useCallback } from "react";

import { css } from "@compiled/react";

import AutoCompleteSearchBar from "./auto-complete-search-bar";

const mobileSearchBarStyle = css({
    marginInlineStart: "25px",
    marginInlineEnd: "25px",
    width: "100%"
});

const SearchBar = ({
    setIsOpenSearch,
    isMobile = false
}: {
    readonly setIsOpenSearch: React.Dispatch<React.SetStateAction<boolean>>;
    readonly isMobile?: boolean;
}) => {
    const handleEscKeyEvent = useCallback((event: KeyboardEvent) => {
        if (event.key === "Escape") {
            setIsOpenSearch(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        // Attach the listeners on component mount.
        document.addEventListener("keydown", handleEscKeyEvent, false);
        // Detach the listeners on component unmount.
        return () => {
            document.removeEventListener("keydown", handleEscKeyEvent, false);
        };
    }, [handleEscKeyEvent]);

    return (
        <div
            className="search-bar"
            css={[
                css({
                    marginInlineStart: "25px",
                    marginInlineEnd: "25px",
                    width: "100%"
                }),
                isMobile ? mobileSearchBarStyle : ""
            ]}
        >
            <AutoCompleteSearchBar setIsOpenSearch={setIsOpenSearch} />
        </div>
    );
};

export default SearchBar;
